export const GoogleMapsAPI = "AIzaSyAc7ry49GuPg3XWmyBL3bJAQlaUXuiyZxc";
